import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MyShipPopupComponent } from './my-ship-popup.component';
import { MaterialModule } from '../../material/material.module';
import { MatIconModule } from '@angular/material/icon';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CustomDropdownModule } from '../custom-dropdown/custom-dropdown.module';



@NgModule({
  declarations: [MyShipPopupComponent],
  imports: [
    CommonModule,
    MaterialModule,
    CustomDropdownModule,
    MatIconModule,
    FormsModule,
   
    ReactiveFormsModule,
  ],
  exports: [
    MyShipPopupComponent,

    

  ]
})
export class MyShipPopupModule { }
